/**
 * Lightweight fallback while lazy route chunks load.
 */
function RoutePageLoader() {
  return (
    <div className="d-flex justify-content-center align-items-center py-5" role="status" aria-live="polite">
      <div className="spinner-border text-primary" aria-hidden="true" />
      <span className="visually-hidden">Pagina laden…</span>
    </div>
  );
}

export default RoutePageLoader;
